import Edu from '../Asset/Skills/Education.svg'
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger'
gsap.registerPlugin(useGSAP,ScrollTrigger);

const Education = () => {

  useGSAP(() => {

    gsap.from("#EducationHash", { y: 50, opacity: 0.5 ,duration: 1.5, ease: "ease.in", delay: 1, scrollTrigger:{trigger:"#EducationHash",toggleActions:"restart pause  reverse pause"} });
  })
  return(
  <>

  <div id='EducationHash' className='flex flex-col g items-center w-full md:flex-row p-2  justify-center justify-items-center font-sans text-justify mt-5 gap-3 '>
    <div className='flex flex-col   h-56 lg:h-80 font-roboto  bg-red-100 shadow-lg border-2  w-full   '>
        <section className='flex flex-col  p-2 w-3/2   h-72  text-center lg:text-left md:te  '>
        <h1 className='text-2xl font-bold p-2 ml-2 lg:text-3xl italic font-sans'>B.Tech.<span className='text-sm'>(Bachelor of Technology)</span></h1>
        <p className='ml-2 text-md  lg:text-2xl font-sans '>Computer Science & Engineering (CSE)</p>
        <span className='ml-2 text-sm italic lg:text-lg font-sans' >Rajasthn Technical University of Kota</span>
        <span className='align-middle text-sm italic  shadow-stone-400 lg:text-lg lg:ml-72'> <span className='text-3xl'></span>2018-2022</span>
        <p className='ml-4 text-md mt-8 lg:text-2xl  font-roboto  '>✅ Completed with 7.90 CGPA.</p>
        </section>

    </div>
    <div className='   shadow-lg flex justify-center  justify-items-center w-11/12  lg:mt-0  '>
        <img  src={Edu} alt='education'/>

    </div>


  </div>





  </>)
};
export default Education;
